import React from 'react';
import { useSelector } from 'react-redux'

import Select from '@material-ui/core/Select';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

export default function SelectRepositoryItemType(props) {

    const repositoryState = useSelector(state => state.repository)
    const itemTypesFetched = !!repositoryState.itemTypes.length

    return (
        <Select
            className={props.className}
            value={props.value || 'all'}
            onChange={props.onChange}
            disabled={!itemTypesFetched}
        >
            <MenuItem value='all'>
                <Grid item container justify="space-between">
                    <em>Todos os itens </em>
                </Grid>
            </MenuItem>
            {itemTypesFetched && repositoryState.itemTypes.map(itemType => (
                <MenuItem key={itemType.id} value={itemType.id}>
                    <Typography variant="subheading" noWrap>
                        {itemType.name}
                    </Typography>
                </MenuItem>
            ))}
        </Select>
    );
}